var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registrazione"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-lg-10 offset-lg-1"},[_c('app-add-minore',{attrs:{"userData":_vm.registration}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }